import React, { useState } from 'react';
import { Field } from 'react-final-form'
import { required, isEmail } from "../../utils/validation";

function Text(props: any) {
  const [hasClickedNext, setHasClickedNext] = useState(false);

  const submitAnswer = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }

    props.moveToNext();
  }

  const clickNextAction = (meta: any) => {
    setHasClickedNext(true);
    
    if (!meta.error) {
      props.moveToNext()
    }
  }

  return (
      <>
      <Field 
        name={`${props.baseName}[answer]`}
        onKeyPress={(e: any) => {
              if (e.key === 'Enter') submitAnswer(e);
        }}
        validate={(value: string) => props.question.mod_type === "email" ? isEmail(value, !props.question.required) : props.question.required ? required(value) : undefined} 
          >
          {({ input, meta }) => (
          <>
      <div className="text-input-wrapper">
              <input type="text" {...input} className="text-input"  />
      </div>
      <div>
        {(meta.touched || hasClickedNext)  && meta.error && <span className="input-error">{meta.error}</span>}          
      </div>
        <button className="nextButton" onClick={() => clickNextAction(meta)}>Next</button>
      </>
      )}
      </Field>
      </>
  );
}

export default Text;
